// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"8f00b0c1","856":"19ab0e07","935":"675ae09a"}[chunkId] + ".js";
};